var _path, _path2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalViewsIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 15.2383C9.17909 15.2383 9 15.4174 9 15.6383V16.9934C9 17.07 9.02194 17.1449 9.06323 17.2093L14.0782 25.0345C14.1585 25.1598 14.1626 25.3193 14.0888 25.4485L9.05259 34.2738C9.01813 34.3342 9 34.4025 9 34.472V35.8383C9 36.0592 9.17909 36.2383 9.4 36.2383H21.6C21.8209 36.2383 22 36.0592 22 35.8383V31.6383C22 31.4174 21.8209 31.2383 21.6 31.2383H20.1844C19.9668 31.2383 19.7891 31.4122 19.7845 31.6297L19.7351 33.932C19.7304 34.1495 19.5527 34.3234 19.3351 34.3234H12.339C12.0316 34.3234 11.8391 33.9911 11.992 33.7244L16.7372 25.448C16.8111 25.319 16.8074 25.1597 16.7277 25.0343L12.1057 17.7679C11.9364 17.5016 12.1277 17.1532 12.4433 17.1532H19.3489C19.5609 17.1532 19.7361 17.3186 19.7482 17.5303L19.8816 19.8611C19.8938 20.0728 20.069 20.2383 20.281 20.2383H21.6C21.8209 20.2383 22 20.0592 22 19.8383V15.6383C22 15.4174 21.8209 15.2383 21.6 15.2383H9.4Z",
    fill: "#522D56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8495 26.3811C40.4054 26.6463 40.9883 26.0593 40.6152 25.5691C38.1492 22.3295 34.2521 20.2383 29.8665 20.2383C25.481 20.2383 21.5839 22.3294 19.1179 25.569C18.7448 26.0591 19.3277 26.6462 19.8836 26.381C21.3516 25.6806 22.9835 25.1305 24.7318 24.7631C24.4958 25.3761 24.3665 26.0421 24.3665 26.7383C24.3665 29.7758 26.8289 32.2383 29.8665 32.2383C32.9041 32.2383 35.3665 29.7758 35.3665 26.7383C35.3665 26.0421 35.2371 25.3762 35.0012 24.7631C36.7496 25.1306 38.3815 25.6807 39.8495 26.3811ZM33.3665 26.7383C33.3665 28.6713 31.7995 30.2383 29.8665 30.2383C27.9335 30.2383 26.3665 28.6713 26.3665 26.7383C26.3665 24.8053 27.9335 23.2383 29.8665 23.2383C31.7995 23.2383 33.3665 24.8053 33.3665 26.7383Z",
    fill: "#522D56"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 44.2383,
    x2: 44,
    y2: 44.2383,
    stroke: "#522D56",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalViewsIconSelected);
export default __webpack_public_path__ + "static/media/TotalViews_icon_selected.af8fcc0e28ba2432ee3c449b7eb799a8.svg";
export { ForwardRef as ReactComponent };